import { apiTimezoneIdsToLetterCodes } from 'bdata-game-utils/utils/timezoneConfigs';
import getTranslation from 'bdata-sns-shared/utils/getTranslation';
import Moment from 'bdata-sns-shared/utils/Moment';
import { formatInTimeZone } from 'date-fns-tz';
import { ja } from 'date-fns/locale';

const getProcessedGameDate = (cfg) => {
    const { gameDate, tz, isPreview, startTimeTBD, game, dictionary, isDoubleHeader, isMiniSB, isMIG, localTimezone, locale } = cfg;
    const moment = Moment.getMoment();
    const momentDate = moment(gameDate);
    const formattedDate = momentDate.format('LT');
    const tzCode = !momentDate.isDST() && apiTimezoneIdsToLetterCodes[tz + ' DT'] || apiTimezoneIdsToLetterCodes[tz] || '';
    let defaultGameDate = `${formattedDate} ${tzCode}`;
    const gameNumberFromGame = game && game.gameNumber;
    let tbdGameDate = '';
    if (localTimezone) {
        defaultGameDate = formatInTimeZone(gameDate, localTimezone, 'h:mm a zz');
    }
    if (locale === 'ja') {
        defaultGameDate = formatInTimeZone(new Date(gameDate), tz, 'h:mm a zzz', { locale: ja, timeZone: tz });
    }
    if (isDoubleHeader && gameNumberFromGame) {
        tbdGameDate = (!isMIG) ? `${getTranslation(dictionary, 'game', 'Game')} ${gameNumberFromGame}` : getTranslation(dictionary, 'game_time_tbd', 'TBD');
        if (isMiniSB) {
            tbdGameDate = tbdGameDate.toUpperCase();
        }
    } else {
        tbdGameDate = getTranslation(dictionary, 'game_time_tbd', 'TBD');
    }
    return (!isPreview) ? defaultGameDate : (startTimeTBD ? tbdGameDate : defaultGameDate);
};

export default getProcessedGameDate;
